var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4DF3749B-650E-4744-9AE4-3D47AB0CC762") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-561.000000, -1706.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logout",
    transform: "translate(561.000000, 1706.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-5",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 0,
    y: 0,
    width: 130,
    height: 22
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D8D8",
    fillRule: "evenodd",
    cx: 12.6666667,
    cy: 10.6666667,
    r: 6.66666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.166339,12.2234273 L122.10441,9 L122.10441,9 L125.282452,12.2519834 C125.438266,12.4114227 125.435327,12.6669861 125.275888,12.8228001 C125.275604,12.8230773 125.27532,12.823354 125.275036,12.8236303 C125.11453,12.9795645 124.858114,12.976232 124.701715,12.8161793 L122.124867,10.1791332 L122.124867,10.1791332 L119.766386,12.7671391 C119.615641,12.9325543 119.359472,12.9448063 119.193628,12.7945327 C119.028408,12.6448242 119.015834,12.3895241 119.165542,12.2243041 C119.165807,12.2240114 119.166073,12.2237192 119.166339,12.2234273 Z",
    id: "Path-186-Copy-5",
    fill: "#909090",
    fillRule: "nonzero",
    transform: "translate(122.229307, 11.000000) scale(-1, -1) rotate(-90.000000) translate(-122.229307, -11.000000) "
  }), /*#__PURE__*/React.createElement("text", {
    id: "Logout",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 6,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 25,
    y: 13,
    fill: "#000000"
  }, "Logout")), /*#__PURE__*/React.createElement("path", {
    d: "M14.4972752,8 L14.4972752,9.08918815 L13.9723911,9.08918815 L13.9723911,8.5248726 L11.5249759,8.5248726 L11.5249759,12.7767885 L13.9723911,12.7767885 L13.9723911,12.2124729 L14.4972752,12.2124729 L14.4972752,13.3016611 L11,13.3016611 L11,8 L14.4972752,8 Z M14.9042093,9.55509727 L16,10.6508765 L14.9042093,11.7466672 L14.536764,11.3726308 L14.9960706,10.9133243 L12.8504199,10.9133243 L12.8504199,10.3884402 L14.9960706,10.3884402 L14.536764,9.92913359 L14.9042093,9.55509727 Z",
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.e280b964711cda694bb791b6a93544d0.svg";
export { ForwardRef as ReactComponent };